<div class="card">
	<div class="card-header">
		<h1>Tabla dinamica</h1>
		<div class="table table-responsive">
			<table class="table table-striped">
				<thead>
					<tr class="title-tr">
						<th [colSpan]="table.headers.length">
							<p class="h5 text-center">{{table.title}}
								<i (click)="table.showFilter = !table.showFilter"
									[class.showed-filter]="table.showFilter"
									class="fa fa-filter clickeable text-info"></i>
							</p>
							<div class="d-flex" *ngIf="table.showFilter">
								<span *ngFor="let header of table.headers" class="clickeable title-show"
									[ngClass]="header.hidden?'':'showed-tab'" (click)="header.hidden = !header.hidden">
									{{ header.title }}
									<i [ngClass]="header.hidden?'fa-square':'fa-square-check'" class="fa"></i>
								</span>
							</div>
						</th>
					</tr>
					<tr>
						<ng-container *ngFor="let header of table.headers; let h = index">
							<th *ngIf="!header.hidden">
								{{ header.title }}
								<ng-container *ngIf="header.sortable">
									<i (click)="sort(h)" tooltip="Ordenar" placement="bottom" [ngClass]="
									(header.sorted === null || header.sorted === undefined)
									?'fa-arrow-right-arrow-left':header.sorted===0 
									?'fa-arrow-down-wide-short':'fa-arrow-up-short-wide'" class="fa clickeable"></i>
								</ng-container>
								<ng-container *ngIf="header.groupable">
									<i (click)="group(h)" tooltip="Agrupar" placement="bottom" [ngClass]="
									(header.grouped)
									?'fa-object-group':'fa-object-ungroup'" class="fa clickeable"></i>
								</ng-container>
							</th>
						</ng-container>
					</tr>
				</thead>
				<tbody>
					<ng-container>
						<tr *ngFor="let register of table.filter">
							<ng-container *ngFor="let cell of register.cells; let i = index">
								<td *ngIf="!table.headers[i].hidden">
									<ng-container *ngIf="table.headers[i].type === 'string' || table.headers[i].type === 'number'">
										{{cell}}
									</ng-container>
									<ng-container *ngIf="table.headers[i].type === 'price'">
										{{cell | currency: 'Q'}}
									</ng-container>
									<ng-container *ngIf="table.headers[i].type === 'date'">
										{{cell | date: 'dd/MM/YYYY'}}
									</ng-container>
								</td>
							</ng-container>
						</tr>
					</ng-container>
				</tbody>
			</table>
		</div>
	</div>
</div>